import { ChangeDetectorRef, Component, Input, inject } from '@angular/core';
import { befreeUrlValues } from 'src/app/shared/constants';
import { TextSizes, TextType } from 'src/app/shared/enums';
import { UtilsService } from 'src/app/shared/services/utils.service';
import { NgClass } from '@angular/common';
import { TextComponent } from '../../text/text.component';
import { IonicModule } from '@ionic/angular';
import { RouterLink } from '@angular/router';
import { ImageComponent } from '../../image/image.component';
import { DateFormatPipe } from '../../../pipe/date-format/date-format.pipe';
import { AddBaseUrlPipe } from '../../../pipe/add-baseUrl/add-base-url.pipe';
import { SvgComponent } from '../../svg/svg.component';
import { YearsOfServiceBadgeIconPipe } from '../../../pipe/years-of-service-badge-icon/years-of-service-badge-icon.pipe';
@Component({
  selector: 'app-post-header',
  templateUrl: './post-header.component.html',
  styleUrls: ['./post-header.component.scss'],
  imports: [
    TextComponent,
    IonicModule,
    RouterLink,
    ImageComponent,
    NgClass,
    DateFormatPipe,
    AddBaseUrlPipe,
    SvgComponent,
    YearsOfServiceBadgeIconPipe,
  ],
})
export class PostHeaderComponent {
  utils = inject(UtilsService);
  private _cdr = inject(ChangeDetectorRef);

  @Input() id?: number;

  @Input() avatar?: string;

  @Input() fullName?: string;

  @Input() position?: string;

  @Input() department?: string;

  @Input() city?: string;

  @Input() date?: string;

  @Input() dateEmployment?: string;

  readonly TextType = TextType;

  readonly TextSizes = TextSizes;

  public isActive = false;

  get link() {
    return ['/', befreeUrlValues.dashboard, befreeUrlValues.employees, this.id];
  }

  public onNameClick() {
    this.isActive = true;
    setTimeout(() => {
      this.isActive = false;
      this._cdr.detectChanges();
    }, 200);
  }
}
